"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./pages/Core/Download/Download.tsx");
require("./pages/Guest/Login.tsx");
require("./pages/Guest/Register.tsx");
require("./pages/Guest/ForgotPassword.tsx");
require("./pages/Core/Confirm/Success.tsx");
require("./pages/Core/ResetPassword/index.tsx");
require("./pages/Core/ResetPassword/confirmed.tsx");
require("./pages/Core/ResetEmail/index.tsx");
require("./pages/Core/ResetEmail/confirmed.tsx");
require("./pages/User/Profile.tsx");
require("./pages/User/Launchpad.tsx");
